/* eslint-disable */
/**
 * Generated from JSON schema. DO NOT EDIT BY HAND.
 * Regenerate with: npm run generate:types
 */

export type GeneratedTypes =
  | SetPlayerResponse
  | AuthenticateResponse
  | CampaignsResponse
  | CampaignsUpdate
  | CampaignProgressResponse
  | CampaignProgressUpdate
  | ConfigureResponse
  | ListGamesResponse
  | GameCampaignsResponse
  | JackpotProgressResponse
  | JackpotProgressUpdate
  | MissionProgressResponse
  | MissionProgressUpdate
  | NotificationsResponse
  | NotificationsUpdate
  | AckNotificationsResponse
  | PrizeDropPrizesResponse
  | PrizeDropPrizesUpdate
  | RaffleProgressResponse
  | RaffleProgressUpdate
  | SprintMissionPoolResponse
  | SprintMissionPoolUpdate
  | TournamentLeaderboardsResponse
  | TournamentLeaderboardsUpdate
  | TournamentPlayerProgressResponse
  | TournamentPlayerProgressUpdate
  | OptInTournamentResponse
  | OptOutTournamentResponse
  | RestartTournamentResponse;
export type SetPlayer = "set_player";
/**
 * Shared result type so JSON schema emits a single $def and one Result type in TS.
 */
export type Result = "ok" | "error";
export type Auth = string | null;
export type Authenticate = "authenticate";
export type SubscribeCampaigns = "subscribe:campaigns";
export type Data = PublicCampaignSchema[] | null;
export type Id = number;
export type CustomId = string;
export type Name = string;
export type Image = string;
export type CoinImage = string;
export type Start = string;
export type End = string;
export type Status = "SC" | "AC" | "FI" | "CA";
export type DisplayUntil = string | null;
export type IsPriority = boolean;
export type HiddenInGame = boolean;
export type Content = string;
export type CampaignInfo = string;
export type Type = "TO" | "RA" | "DP" | "MI" | "JA" | "RF";
export type Subtype = "PT" | "HC" | "RA" | "TM" | "IM" | "DP" | "MI" | "SM" | "JA" | "RF";
export type OptInMethod = string;
export type Value = number;
export type Currency = string;
export type Display = string;
export type MaxSpins = number | null;
export type SpinsBeforeRestart = number | null;
export type EligibleGames = EligibleGameSchema[] | "ALL" | null;
export type Name1 = string;
export type CustomId1 = string;
export type EligibleGamesCount = number | null;
export type Rate = number;
export type GameCount = number;
export type Traits = string[];
export type ContributionRates = ContributionRateGroupSchema[];
export type Title = string;
export type Games = string[];
export type PlaceFrom = number | null;
export type PlaceTo = number | null;
export type Attempts = number | null;
export type Quantity = number | null;
export type LeftToWin = number | null;
export type Value1 = number | null;
export type IsCatalogItem = boolean;
export type Prizes = PrizeSchema[];
export type Order = number;
export type Points = number | null;
export type Title1 = string;
export type Kind = "play" | "win" | "turnover" | "deposit" | "login";
export type Prizes1 = PrizeSchema[] | null;
export type Id1 = number | null;
export type IsActive = boolean | null;
export type IsCompleted = boolean | null;
export type Current = string;
export type Total = string;
export type Tasks = TaskSchema[];
export type Id2 = number;
export type KeepOrder = boolean;
export type Tasks1 = TaskSchema[];
export type Prizes2 = PrizeSchema[];
export type Missions = MissionSchema[];
export type Id3 = number;
export type Title2 = string;
export type JackpotType = string;
export type DisplayOrder = number;
export type BoostedChance = string | null;
export type Value2 = number;
export type Currency1 = string;
export type Display1 = string;
export type Id4 = number;
export type DayOfMonth = number | null;
export type DayOfWeek = number | null;
export type Interval = string;
export type TimespanStart = string | null;
export type TimespanEnd = string | null;
export type Jackpots = JackpotSchema[];
export type DrawTimestamp = string | null;
export type LockedForPrizeDraw = boolean;
export type Drawn = boolean;
export type Id5 = number;
export type Order1 = number;
export type Kind1 = "login" | "deposit" | "turnover";
export type Title3 = string;
export type TicketsPerCompletion = number;
export type MaxTickets = number;
export type Threshold = string;
export type Tasks2 = RaffleTaskSchema[];
export type PrizeTitle = string;
export type Player = string;
export type PlayerUsername = string;
export type PlaceFrom1 = number | null;
export type PlaceTo1 = number | null;
export type PayoutStatus = string;
export type Winners = RaffleWinnerSchema[];
export type UpdateCampaigns = "update:campaigns";
export type Data1 = PublicCampaignSchema[];
export type SubscribeCampaignProgress = "subscribe:campaign_progress";
export type Data2 = CampaignProgressSchema[] | null;
export type Id6 = number;
export type CustomId2 = string;
export type Joined = boolean;
export type EndsAt = string | null;
export type UpdateCampaignProgress = "update:campaign_progress";
export type Data3 = CampaignProgressSchema[];
export type Configure = "configure";
export type ListGames = "action:list_games";
export type RequestId = string | null;
export type Campaign = number | null;
export type Names = string[] | null;
export type Total1 = number | null;
export type NextOffset = number | null;
export type Message = string | null;
export type GameCampaigns = "action:game_campaigns";
export type RequestId1 = string | null;
export type Game = string | null;
export type Campaigns = GameCampaignFitSchema[] | null;
export type Id7 = number;
export type Eligible = boolean;
export type ContributionRate = number;
export type Message1 = string | null;
export type SubscribeJackpotProgress = "subscribe:jackpot_progress";
export type Data4 = JackpotProgressSchema[] | null;
export type Id8 = number;
export type CustomId3 = string;
export type JackpotId = number;
export type Id9 = number;
export type Activated = string | null;
export type IsActive1 = boolean;
export type IsBoostedNow = boolean;
export type IsBoostStartIn1Hour = boolean;
export type IsBoostEndIn1Hour = boolean;
export type NextBoostStart = string | null;
export type BoostEnd = string | null;
export type PayoutBefore = string | null;
export type PayoutDate = string | null;
export type Jackpots1 = JackpotProgressEntrySchema[];
export type Player1 = string;
export type Name2 = string;
export type JackpotId1 = number;
export type WonAt = string;
export type RecentWins = JackpotWinSchema[];
export type UpdateJackpotProgress = "update:jackpot_progress";
export type Data5 = JackpotProgressSchema[];
export type SubscribeMissionProgress = "subscribe:mission_progress";
export type Data6 = MissionProgressSchema[] | null;
export type Id10 = number;
export type CampaignId = number;
export type CampaignCustomId = string;
export type IsActive2 = boolean;
export type IsCompleted1 = boolean;
export type Tasks3 = TaskSchema[];
export type UpdateMissionProgress = "update:mission_progress";
export type Data7 = MissionProgressSchema[];
export type SubscribeNotifications = "subscribe:notifications";
export type Data8 =
  | (
      | BetTooLowNotificationSchema
      | BetBonusExcludedNotificationSchema
      | JackpotWonNotificationSchema
      | MissionCompletedNotificationSchema
      | MissionSecondaryTaskCompleteNotificationSchema
      | MissionPrizePoolExhaustedNotificationSchema
      | TournamentFinishedNotificationSchema
      | TournamentRaceFinishedNotificationSchema
      | TournamentChaseWinPrizeNotificationSchema
      | TournamentSecondaryFinishedNotificationSchema
      | TournamentSecondaryRaceFinishedNotificationSchema
      | TournamentRaceCompletedNotificationSchema
      | TournamentSecondaryMissionCompleteNotificationSchema
      | TournamentNewHighScoreNotificationSchema
      | TournamentSecondaryTaskCompleteNotificationSchema
      | TournamentResetBestScoreNotificationSchema
      | TournamentResetWorstPrizeNotificationSchema
      | PrizeDropWonNotificationSchema
      | PrizeDropRevealedNotificationSchema
      | PrizeDropNearWinNotificationSchema
      | PrizeDropNearDropNotificationSchema
      | PrizeDropPlayerEnteredNotificationSchema
      | PrizeDropChanceIncreaseNotificationSchema
      | PrizeDropChanceDecreaseNotificationSchema
      | PrizeDropCampaignLiveNotificationSchema
      | PrizeDropHotPeriodNotificationSchema
      | PrizeDropFinalStretchNotificationSchema
    )[]
  | null;
export type Id11 = number;
export type CreatedAt = string;
export type CampaignId1 = number;
export type Type1 = "bet_too_low";
export type Id12 = number;
export type CreatedAt1 = string;
export type CampaignId2 = number;
export type Type2 = "bet_bonus_excluded";
export type Id13 = number;
export type CreatedAt2 = string;
export type CampaignId3 = number;
export type Type3 = "jackpot_won";
export type JackpotId2 = number;
export type JackpotTitle = string;
export type PayoutAmount = string;
export type Id14 = number;
export type CreatedAt3 = string;
export type CampaignId4 = number;
export type Type4 = "mission_completed";
export type MissionId = number;
export type MissionOrder = number;
export type RemainingTasksAmount = number;
export type NumbersOfMissions = number;
export type CompletedRepetitions = number;
export type NumberOfRepetitions = number;
export type PrizeTitle1 = string;
export type PayoutAtCampaignEnd = boolean;
export type Id15 = number;
export type CreatedAt4 = string;
export type CampaignId5 = number;
export type Type5 = "mission_secondary_task_complete";
export type MissionTaskId = number;
export type MissionTaskType = string;
export type TaskTitle = string;
export type PrizeTitle2 = string;
export type Id16 = number;
export type CreatedAt5 = string;
export type CampaignId6 = number;
export type Type6 = "mission_prize_pool_exhausted";
export type Id17 = number;
export type CreatedAt6 = string;
export type CampaignId7 = number;
export type Type7 = "tournament_finished";
export type PlayerPlace = number;
export type PrizeTitle3 = string;
export type Id18 = number;
export type CreatedAt7 = string;
export type CampaignId8 = number;
export type Type8 = "tournament_race_finished";
export type PlayerPlace1 = number;
export type PrizeTitle4 = string;
export type Id19 = number;
export type CreatedAt8 = string;
export type CampaignId9 = number;
export type Type9 = "tournament_chase_win_prize";
export type PrizeTitle5 = string;
export type Id20 = number;
export type CreatedAt9 = string;
export type CampaignId10 = number;
export type Type10 = "tournament_secondary_finished";
export type PlayerPlace2 = number;
export type Id21 = number;
export type CreatedAt10 = string;
export type CampaignId11 = number;
export type Type11 = "tournament_secondary_race_finished";
export type PlayerPlace3 = number;
export type Id22 = number;
export type CreatedAt11 = string;
export type CampaignId12 = number;
export type Type12 = "tournament_race_completed";
export type PlayerPlace4 = number;
export type Id23 = number;
export type CreatedAt12 = string;
export type CampaignId13 = number;
export type Type13 = "tournament_secondary_mission_complete";
export type SpinsNum = number;
export type PlayerPlace5 = number;
export type Id24 = number;
export type CreatedAt13 = string;
export type CampaignId14 = number;
export type Type14 = "tournament_new_high_score";
export type NewHighScore = number;
export type PlayerPlace6 = number;
export type Id25 = number;
export type CreatedAt14 = string;
export type CampaignId15 = number;
export type Type15 = "tournament_secondary_task_complete";
export type TaskId = number;
export type TaskType = string;
export type Id26 = number;
export type CreatedAt15 = string;
export type CampaignId16 = number;
export type Type16 = "tournament_reset_best_score";
export type Id27 = number;
export type CreatedAt16 = string;
export type CampaignId17 = number;
export type Type17 = "tournament_reset_worst_prize";
export type Id28 = number;
export type CreatedAt17 = string;
export type CampaignId18 = number;
export type Type18 = "prize_drop_won";
export type DropKey = string;
export type Prizes3 = PrizeDropWonPrizeSchema[];
export type Id29 = number;
export type CreatedAt18 = string;
export type CampaignId19 = number;
export type Type19 = "prize_drop_revealed";
export type DropKey1 = string;
export type Title4 = string;
export type Games1 = string[];
export type Prizes4 = PrizeDropRevealedPrizeSchema[];
export type Id30 = number;
export type CreatedAt19 = string;
export type CampaignId20 = number;
export type Type20 = "prize_drop_near_win";
export type Id31 = number;
export type CreatedAt20 = string;
export type CampaignId21 = number;
export type Type21 = "prize_drop_near_drop";
export type Id32 = number;
export type CreatedAt21 = string;
export type CampaignId22 = number;
export type Type22 = "prize_drop_player_entered";
export type Id33 = number;
export type CreatedAt22 = string;
export type CampaignId23 = number;
export type Type23 = "prize_drop_chance_increase";
export type Id34 = number;
export type CreatedAt23 = string;
export type CampaignId24 = number;
export type Type24 = "prize_drop_chance_decrease";
export type Id35 = number;
export type CreatedAt24 = string;
export type CampaignId25 = number;
export type Type25 = "prize_drop_campaign_live";
export type Id36 = number;
export type CreatedAt25 = string;
export type CampaignId26 = number;
export type Type26 = "prize_drop_hot_period";
export type Id37 = number;
export type CreatedAt26 = string;
export type CampaignId27 = number;
export type Type27 = "prize_drop_final_stretch";
export type UpdateNotifications = "update:notifications";
export type Data9 = (
  | BetTooLowNotificationSchema
  | BetBonusExcludedNotificationSchema
  | JackpotWonNotificationSchema
  | MissionCompletedNotificationSchema
  | MissionSecondaryTaskCompleteNotificationSchema
  | MissionPrizePoolExhaustedNotificationSchema
  | TournamentFinishedNotificationSchema
  | TournamentRaceFinishedNotificationSchema
  | TournamentChaseWinPrizeNotificationSchema
  | TournamentSecondaryFinishedNotificationSchema
  | TournamentSecondaryRaceFinishedNotificationSchema
  | TournamentRaceCompletedNotificationSchema
  | TournamentSecondaryMissionCompleteNotificationSchema
  | TournamentNewHighScoreNotificationSchema
  | TournamentSecondaryTaskCompleteNotificationSchema
  | TournamentResetBestScoreNotificationSchema
  | TournamentResetWorstPrizeNotificationSchema
  | PrizeDropWonNotificationSchema
  | PrizeDropRevealedNotificationSchema
  | PrizeDropNearWinNotificationSchema
  | PrizeDropNearDropNotificationSchema
  | PrizeDropPlayerEnteredNotificationSchema
  | PrizeDropChanceIncreaseNotificationSchema
  | PrizeDropChanceDecreaseNotificationSchema
  | PrizeDropCampaignLiveNotificationSchema
  | PrizeDropHotPeriodNotificationSchema
  | PrizeDropFinalStretchNotificationSchema
)[];
export type AckNotifications = "ack:notifications";
export type SubscribePrizeDropPrizes = "subscribe:prize_drop_prizes";
export type Data10 = PrizeDropPrizesSchema[] | null;
export type Id38 = number;
export type CustomId4 = string;
export type Title5 = string;
export type Games2 = string[];
export type IsCatalogItem1 = boolean;
export type Quantity1 = number;
export type LeftToWin1 = number;
export type Prizes5 = PrizeDropPrizeSchema[];
export type MaxPrizesPerPlayer = number | null;
export type UpdatePrizeDropPrizes = "update:prize_drop_prizes";
export type Data11 = PrizeDropPrizesSchema[];
export type SubscribeRaffleProgress = "subscribe:raffle_progress";
export type Data12 = RaffleProgressSchema[] | null;
export type CampaignId28 = number;
export type CampaignCustomId1 = string;
export type TotalTickets = number;
export type TaskId1 = number;
export type Tickets = number;
export type MaxTickets1 = number;
export type Tasks4 = RaffleTaskProgressSchema[];
export type UpdateRaffleProgress = "update:raffle_progress";
export type Data13 = RaffleProgressSchema[];
export type SubscribeSprintMissionPool = "subscribe:sprint_mission_pool";
export type Data14 = SprintMissionPoolSchema[] | null;
export type Id39 = number;
export type CustomId5 = string;
export type PrizePoolSize = number;
export type PrizesRemaining = number;
export type Exhausted = boolean;
export type PayoutTiming = "instant" | "end_of_campaign";
export type Player2 = string;
export type Name3 = string;
export type Slot = number | null;
export type WonAt1 = string;
export type RecentWinners = SprintMissionWinnerSchema[];
export type UpdateSprintMissionPool = "update:sprint_mission_pool";
export type Data15 = SprintMissionPoolSchema[];
export type SubscribeTournamentLeaderboards = "subscribe:tournament_leaderboards";
export type Data16 = TournamentLeaderboardsSchema[] | null;
export type Id40 = number;
export type CustomId6 = string;
export type Player3 = string;
export type Score = string;
export type Rank = number;
export type Leaderboard = LeaderboardEntrySchema[];
export type UpdateTournamentLeaderboards = "update:tournament_leaderboards";
export type Data17 = TournamentLeaderboardsSchema[];
export type SubscribeTournamentProgress = "subscribe:tournament_progress";
export type Data18 = PlayerTournamentProgressSchema[] | null;
export type Id41 = number;
export type CustomId7 = string;
export type Joined1 = boolean;
export type LeaderboardPosition = number | null;
export type Score1 = number | null;
export type LeftSpins = number | null;
export type Current1 = number | null;
export type Total2 = number | null;
export type CanReset = boolean | null;
export type Title6 = string;
export type Attempts1 = number | null;
export type Prizes6 = CampaignWinningSchema[];
export type Tasks5 = TaskSchema[] | null;
export type UpdateTournamentProgress = "update:tournament_progress";
export type Data19 = PlayerTournamentProgressSchema[];
export type OptInTournament = "action:opt_in";
export type Result1 = "ok" | "error";
export type OptOutTournament = "action:opt_out";
export type Result2 = "ok" | "error";
export type RestartTournament = "action:restart_tournament";
export type Result3 = "ok" | "error";

export interface SetPlayerResponse {
  type: SetPlayer;
  result: Result;
  auth: Auth;
  [k: string]: unknown;
}
export interface AuthenticateResponse {
  type: Authenticate;
  result: Result;
  [k: string]: unknown;
}
export interface CampaignsResponse {
  type: SubscribeCampaigns;
  result: Result;
  data?: Data;
  [k: string]: unknown;
}
/**
 * The type-agnostic `campaigns` stream: the structural, fixed-once-live campaign data every
 * campaign type shares, PLUS `opt_in_method` / `minimum_bet` / `eligible_games` and the uniform
 * `prizes` / `tasks` (superset schemas rendered per type).
 *
 * A NEW schema, deliberately NOT an extension of `CampaignSchema` (the minimal base shared with
 * `CampaignMapper`) — kept separate so this served shape can carry the extra fields without
 * touching the base. The FE joins this against `prize_drop_prizes` / `campaign_progress` by
 * `id` / `custom_id`.
 */
export interface PublicCampaignSchema {
  id: Id;
  custom_id: CustomId;
  name: Name;
  image: Image;
  coin_image: CoinImage;
  start: Start;
  end: End;
  status: Status;
  display_until?: DisplayUntil;
  is_priority?: IsPriority;
  hidden_in_game?: HiddenInGame;
  terms: CampaignTerms;
  campaign_info: CampaignInfo;
  type: Type;
  subtype: Subtype;
  opt_in_method: OptInMethod;
  minimum_bet?: MinimumBetSchema | null;
  max_spins?: MaxSpins;
  spins_before_restart?: SpinsBeforeRestart;
  eligible_games?: EligibleGames;
  eligible_games_count?: EligibleGamesCount;
  contribution_rates?: ContributionRates;
  prizes?: Prizes;
  tasks?: Tasks;
  missions?: Missions;
  jackpots?: Jackpots;
  raffle?: RaffleSchema | null;
  [k: string]: unknown;
}
export interface CampaignTerms {
  content: Content;
}
export interface MinimumBetSchema {
  value: Value;
  currency: Currency;
  display: Display;
  [k: string]: unknown;
}
export interface EligibleGameSchema {
  name: Name1;
  custom_id: CustomId1;
  [k: string]: unknown;
}
/**
 * One line of the campaign's "how games count" summary (#3783): a contribution rate and
 * how many of the campaign's games resolve to it.
 *
 * Grouped, never per game — a campaign's configured rows run to tens of thousands (one per
 * matched game for a bulk-by-attribute rule), which is the same reason `eligible_games`
 * is windowed behind a dialog rather than listed.
 *
 * Games with no configured rate are absent by construction rather than being a 100% group:
 * they count in full, and "everything else counts in full" is one line of copy, not a row
 * whose `game_count` would mean "the rest of the catalogue".
 */
export interface ContributionRateGroupSchema {
  rate: Rate;
  game_count: GameCount;
  traits?: Traits;
  [k: string]: unknown;
}
/**
 * The canonical, type-agnostic campaign prize — a SUPERSET of every per-type prize schema
 * (TournamentPrizeSchema, PrizeDropPrizeSchema). One schema for all campaign types; the mapper
 * populates only the fields a given type has (tournament → places; others leave them null). This
 * is what lets the tournament subscription eventually be served from the `campaigns` stream
 * (Phase 4) without a bespoke prize shape.
 *
 * Because it is a strict superset, adding a new campaign type NEVER widens this schema: a type
 * either fills existing fields or leaves them null. New fields are added here only when a genuinely
 * new prize dimension appears, and must stay optional so every other type keeps validating.
 *
 * Volatile drop-tracking (`left_to_win`) still rides the `prize_drop_prizes` stream, not here.
 */
export interface PrizeSchema {
  title: Title;
  games?: Games;
  place_from?: PlaceFrom;
  place_to?: PlaceTo;
  attempts?: Attempts;
  quantity?: Quantity;
  left_to_win?: LeftToWin;
  value?: Value1;
  is_catalog_item?: IsCatalogItem;
  [k: string]: unknown;
}
/**
 * The canonical, type-agnostic campaign task — a SUPERSET of TournamentTaskSchema. Campaign
 * types without tasks (e.g. prize drops) render an empty list. Kept a superset for the same reason
 * as PrizeSchema: new types fill or omit fields, never force a widening.
 */
export interface TaskSchema {
  order: Order;
  points?: Points;
  title: Title1;
  kind: Kind;
  prizes?: Prizes1;
  id?: Id1;
  is_active?: IsActive;
  is_completed?: IsCompleted;
  progress?: ProgressSchema | null;
  [k: string]: unknown;
}
/**
 * Generic current/total counter. Lives here (the primitive layer per-type schemas import
 * FROM) rather than in a per-type module, so any future per-type schema can reuse it.
 */
export interface ProgressSchema {
  current: Current;
  total: Total;
  [k: string]: unknown;
}
/**
 * Non-volatile mission definition, embedded in PublicCampaignSchema.missions. The tasks carry
 * only structural fields (per-player fields left null — invariant 5).
 */
export interface MissionSchema {
  id: Id2;
  keep_order: KeepOrder;
  tasks: Tasks1;
  prizes: Prizes2;
  [k: string]: unknown;
}
/**
 * Non-volatile jackpot definition, embedded in PublicCampaignSchema.jackpots (a plain nested
 * dict row, not a dao attribute — no `_src` aliasing needed, mirroring TaskSchema/PrizeSchema).
 * The live pot value / boost-window state rides the separate `jackpot_progress` stream (widgets
 * invariant 3) — this carries only what's fixed once the campaign is live, mirroring
 * MissionSchema's split.
 *
 * Field set mirrors `overlay.api.serializers.jackpots.OverlayJackpotSerializer` exactly (parity
 * audit, #3800) — surface exactly what the legacy overlay already sends, no more, no less; the
 * FE decides what to do with it.
 */
export interface JackpotSchema {
  id: Id3;
  title: Title2;
  jackpot_type: JackpotType;
  display_order: DisplayOrder;
  boosted_chance?: BoostedChance;
  max_payout_amount?: MoneySchema | null;
  timespan?: JackpotTimespanSchema | null;
  [k: string]: unknown;
}
/**
 * Generic display-currency-converted amount (value/currency/display), reused wherever a
 * schema needs a formatted money value — e.g. PublicCampaignSchema.minimum_bet's shape, jackpot
 * max payouts, jackpot pot progress. Lives here (the primitive layer) rather than duplicated per
 * schema module.
 */
export interface MoneySchema {
  value: Value2;
  currency: Currency1;
  display: Display1;
  [k: string]: unknown;
}
/**
 * Mirrors OverlayJackpotTimespanSerializer field-for-field — TIMED jackpots only (null
 * otherwise, matching Jackpot.timespan itself being null for PROGRESSIVE/PAYOUT_BEFORE).
 */
export interface JackpotTimespanSchema {
  id: Id4;
  day_of_month?: DayOfMonth;
  day_of_week?: DayOfWeek;
  interval: Interval;
  timespan_start?: TimespanStart;
  timespan_end?: TimespanEnd;
  [k: string]: unknown;
}
export interface RaffleSchema {
  draw_timestamp: DrawTimestamp;
  locked_for_prize_draw: LockedForPrizeDraw;
  drawn: Drawn;
  tasks: Tasks2;
  winners?: Winners;
  [k: string]: unknown;
}
export interface RaffleTaskSchema {
  id: Id5;
  order: Order1;
  kind: Kind1;
  title: Title3;
  tickets_per_completion: TicketsPerCompletion;
  max_tickets: MaxTickets;
  threshold: Threshold;
  [k: string]: unknown;
}
export interface RaffleWinnerSchema {
  prize_title: PrizeTitle;
  player: Player;
  player_username: PlayerUsername;
  place_from: PlaceFrom1;
  place_to: PlaceTo1;
  payout_status: PayoutStatus;
  [k: string]: unknown;
}
export interface CampaignsUpdate {
  type: UpdateCampaigns;
  result: Result;
  data: Data1;
  [k: string]: unknown;
}
export interface CampaignProgressResponse {
  type: SubscribeCampaignProgress;
  result: Result;
  data?: Data2;
  [k: string]: unknown;
}
/**
 * The per-player `campaign_progress` stream: opt-in (`joined`) state for one served campaign,
 * keyed by the campaign identifiers so the FE joins it against `campaigns` / `prize_drop_prizes`.
 *
 * Type-agnostic — `joined` is common to every campaign type (each annotates the same OPTED_IN /
 * NO_OPT_IN rule against its campaign). Tournament-specific progress (leaderboard/score/won-prizes)
 * keeps its own stream; this carries only the shared join state. `id`/`custom_id` are the
 * campaign's own fields (the dao is Campaign), so no aliasing is needed.
 */
export interface CampaignProgressSchema {
  id: Id6;
  custom_id: CustomId2;
  joined: Joined;
  ends_at?: EndsAt;
  [k: string]: unknown;
}
export interface CampaignProgressUpdate {
  type: UpdateCampaignProgress;
  result: Result;
  data: Data3;
  [k: string]: unknown;
}
export interface ConfigureResponse {
  type: Configure;
  result: Result;
  [k: string]: unknown;
}
/**
 * One page of a campaign's eligible game names (the games dialog of an "All games"
 * campaign, whose names never ship on the campaigns stream).
 */
export interface ListGamesResponse {
  type: ListGames;
  result: Result;
  request_id?: RequestId;
  campaign?: Campaign;
  names?: Names;
  total?: Total1;
  next_offset?: NextOffset;
  message?: Message;
  [k: string]: unknown;
}
/**
 * How the game the overlay is docked beside counts toward each campaign the player is served:
 * in the campaign's selection or not, and at what contribution rate (`0..1`).
 */
export interface GameCampaignsResponse {
  type: GameCampaigns;
  result: Result;
  request_id?: RequestId1;
  game?: Game;
  campaigns?: Campaigns;
  message?: Message1;
  [k: string]: unknown;
}
/**
 * How the overlay's game counts toward one served campaign.
 */
export interface GameCampaignFitSchema {
  id: Id7;
  eligible: Eligible;
  contribution_rate: ContributionRate;
  [k: string]: unknown;
}
export interface JackpotProgressResponse {
  type: SubscribeJackpotProgress;
  result: Result;
  data?: Data4;
  [k: string]: unknown;
}
/**
 * SHARED `jackpot_progress` stream — one entry per served jackpot campaign, mirroring
 * `TournamentLeaderboardsSchema`'s shape exactly (id/custom_id = the CAMPAIGN's, so the FE joins
 * this against `campaigns` by id). Deliberately light: no title/type/max-payout (those are
 * structural, and ride `campaigns` — see `JackpotSchema`).
 */
export interface JackpotProgressSchema {
  id: Id8;
  custom_id: CustomId3;
  jackpots: Jackpots1;
  recent_wins: RecentWins;
  total?: MoneySchema | null;
  [k: string]: unknown;
}
export interface JackpotProgressEntrySchema {
  jackpot_id: JackpotId;
  jackpot_events: JackpotEventsSchema;
  [k: string]: unknown;
}
/**
 * Mirrors `OverlayJackpotSerializer.get_jackpot_events`'s `{active, next, last}` shape: the
 * currently active event, the next scheduled one (TIMED jackpots with pre-created future
 * slots), and the most recently paid-out one — each independently null if it doesn't exist.
 * Fetched via clean top-1-per-jackpot subqueries in the mapper (not the legacy's shared
 * top-2-row window, which can silently drop `next` or `last` when both exist alongside
 * `active` — see JackpotProgressMapper's docstring).
 */
export interface JackpotEventsSchema {
  active?: JackpotEventScheduleSchema | null;
  next?: JackpotEventScheduleSchema | null;
  last?: JackpotEventScheduleSchema | null;
  [k: string]: unknown;
}
/**
 * One JackpotEvent's live state — mirrors `OverlayJackpotEventSerializer` field-for-field
 * (parity audit, #3800): surface exactly what the legacy overlay already sends, no more, no
 * less. `is_winner` is deliberately OMITTED — it is per-player (`player == event.winner`) and
 * this is a SHARED stream (widgets invariant 4a, one render per currency/language variant, not
 * per player); adding it needs its own per-player delivery mechanism, not a field bolted onto a
 * shared cache. Flagged as a follow-up, not silently dropped.
 */
export interface JackpotEventScheduleSchema {
  id: Id9;
  activated: Activated;
  is_active: IsActive1;
  is_boosted_now: IsBoostedNow;
  is_boost_start_in_1_hour: IsBoostStartIn1Hour;
  is_boost_end_in_1_hour: IsBoostEndIn1Hour;
  next_boost_start: NextBoostStart;
  boost_end: BoostEnd;
  payout_amount: MoneySchema;
  payout_before: PayoutBefore;
  payout_date: PayoutDate;
  jackpot_value: MoneySchema;
  [k: string]: unknown;
}
/**
 * One paid-out JackpotEvent, for the widget's "latest wins" feed. Mirrors
 * `SprintMissionWinnerSchema` plus the two facts a jackpot win has that a slot claim hasn't:
 * which jackpot (`jackpot_id`, joins `JackpotSchema` on `campaigns`) and how much (`amount`,
 * display-currency-converted exactly like `payout_amount`). `player` is `Player.hash` — this is a
 * SHARED stream (one render per currency/language, never per player), so "You" is the FE
 * comparing the hash it authenticated with, never an `is_winner` flag baked into the cache.
 * `name` is `Player.username`, stored already masked by the platform adapters ("ale**").
 */
export interface JackpotWinSchema {
  player: Player1;
  name: Name2;
  jackpot_id: JackpotId1;
  amount: MoneySchema;
  won_at: WonAt;
  [k: string]: unknown;
}
export interface JackpotProgressUpdate {
  type: UpdateJackpotProgress;
  result: Result;
  data: Data5;
  [k: string]: unknown;
}
export interface MissionProgressResponse {
  type: SubscribeMissionProgress;
  result: Result;
  data?: Data6;
  [k: string]: unknown;
}
/**
 * One mission's per-player state — the mission_progress stream element. Mirrors MissionSchema's
 * shape (same nested `tasks`, plus per-player state) so the FE can fold the two into one complete
 * "mission layout with prizes and current progress": MissionSchema (from `campaigns`) supplies the
 * structure + prizes, this supplies the live state. Join key is campaign_id/campaign_custom_id
 * (Mission has no custom_id) + own PK.
 *
 * Deliberately carries NO prizes (mission- or task-level): prize titles are costly to render
 * (game/catalog lookups) and this stream renders every ~1s per player, unlike `campaigns` which is
 * cached hard and pushed once. Prize rendering is reserved for the shared `campaigns` stream — see
 * `presentation/CLAUDE.md`.
 */
export interface MissionProgressSchema {
  id: Id10;
  campaign_id: CampaignId;
  campaign_custom_id: CampaignCustomId;
  is_active: IsActive2;
  is_completed: IsCompleted1;
  progress: ProgressSchema;
  tasks: Tasks3;
  [k: string]: unknown;
}
export interface MissionProgressUpdate {
  type: UpdateMissionProgress;
  result: Result;
  data: Data7;
  [k: string]: unknown;
}
export interface NotificationsResponse {
  type: SubscribeNotifications;
  result: Result;
  data?: Data8;
  [k: string]: unknown;
}
export interface BetTooLowNotificationSchema {
  id: Id11;
  created_at: CreatedAt;
  campaign_id: CampaignId1;
  type?: Type1;
  [k: string]: unknown;
}
export interface BetBonusExcludedNotificationSchema {
  id: Id12;
  created_at: CreatedAt1;
  campaign_id: CampaignId2;
  type?: Type2;
  [k: string]: unknown;
}
export interface JackpotWonNotificationSchema {
  id: Id13;
  created_at: CreatedAt2;
  campaign_id: CampaignId3;
  type?: Type3;
  jackpot_id: JackpotId2;
  jackpot_title: JackpotTitle;
  payout_amount: PayoutAmount;
  [k: string]: unknown;
}
export interface MissionCompletedNotificationSchema {
  id: Id14;
  created_at: CreatedAt3;
  campaign_id: CampaignId4;
  type?: Type4;
  mission_id: MissionId;
  mission_order: MissionOrder;
  remaining_tasks_amount: RemainingTasksAmount;
  numbers_of_missions: NumbersOfMissions;
  completed_repetitions: CompletedRepetitions;
  number_of_repetitions: NumberOfRepetitions;
  prize_title: PrizeTitle1;
  payout_at_campaign_end?: PayoutAtCampaignEnd;
  [k: string]: unknown;
}
export interface MissionSecondaryTaskCompleteNotificationSchema {
  id: Id15;
  created_at: CreatedAt4;
  campaign_id: CampaignId5;
  type?: Type5;
  mission_task_id: MissionTaskId;
  mission_task_type: MissionTaskType;
  task_title: TaskTitle;
  prize_title: PrizeTitle2;
  [k: string]: unknown;
}
export interface MissionPrizePoolExhaustedNotificationSchema {
  id: Id16;
  created_at: CreatedAt5;
  campaign_id: CampaignId6;
  type?: Type6;
  [k: string]: unknown;
}
export interface TournamentFinishedNotificationSchema {
  id: Id17;
  created_at: CreatedAt6;
  campaign_id: CampaignId7;
  type?: Type7;
  player_place: PlayerPlace;
  prize_title: PrizeTitle3;
  [k: string]: unknown;
}
export interface TournamentRaceFinishedNotificationSchema {
  id: Id18;
  created_at: CreatedAt7;
  campaign_id: CampaignId8;
  type?: Type8;
  player_place: PlayerPlace1;
  prize_title: PrizeTitle4;
  [k: string]: unknown;
}
export interface TournamentChaseWinPrizeNotificationSchema {
  id: Id19;
  created_at: CreatedAt8;
  campaign_id: CampaignId9;
  type?: Type9;
  prize_title: PrizeTitle5;
  [k: string]: unknown;
}
export interface TournamentSecondaryFinishedNotificationSchema {
  id: Id20;
  created_at: CreatedAt9;
  campaign_id: CampaignId10;
  type?: Type10;
  player_place: PlayerPlace2;
  [k: string]: unknown;
}
export interface TournamentSecondaryRaceFinishedNotificationSchema {
  id: Id21;
  created_at: CreatedAt10;
  campaign_id: CampaignId11;
  type?: Type11;
  player_place: PlayerPlace3;
  [k: string]: unknown;
}
export interface TournamentRaceCompletedNotificationSchema {
  id: Id22;
  created_at: CreatedAt11;
  campaign_id: CampaignId12;
  type?: Type12;
  player_place: PlayerPlace4;
  [k: string]: unknown;
}
export interface TournamentSecondaryMissionCompleteNotificationSchema {
  id: Id23;
  created_at: CreatedAt12;
  campaign_id: CampaignId13;
  type?: Type13;
  spins_num: SpinsNum;
  player_place: PlayerPlace5;
  [k: string]: unknown;
}
export interface TournamentNewHighScoreNotificationSchema {
  id: Id24;
  created_at: CreatedAt13;
  campaign_id: CampaignId14;
  type?: Type14;
  new_high_score: NewHighScore;
  player_place: PlayerPlace6;
  [k: string]: unknown;
}
export interface TournamentSecondaryTaskCompleteNotificationSchema {
  id: Id25;
  created_at: CreatedAt14;
  campaign_id: CampaignId15;
  type?: Type15;
  task_id: TaskId;
  task_type: TaskType;
  [k: string]: unknown;
}
export interface TournamentResetBestScoreNotificationSchema {
  id: Id26;
  created_at: CreatedAt15;
  campaign_id: CampaignId16;
  type?: Type16;
  [k: string]: unknown;
}
export interface TournamentResetWorstPrizeNotificationSchema {
  id: Id27;
  created_at: CreatedAt16;
  campaign_id: CampaignId17;
  type?: Type17;
  [k: string]: unknown;
}
export interface PrizeDropWonNotificationSchema {
  id: Id28;
  created_at: CreatedAt17;
  campaign_id: CampaignId18;
  type?: Type18;
  prizes: Prizes3;
  [k: string]: unknown;
}
/**
 * One pending prize of a (merged) won-notification — deliberately **only** the opaque ack
 * key. `drop_key` is the stable per-drop identity the client echoes back in
 * `ack:notifications`' `prizes` payload, so a single prize can be acked (removed from the row)
 * the moment the player confirms its reveal.
 *
 * No `title` (ticket #3922). Once crediting is gated on a player-confirmed reveal (#3804), the
 * reveal is what the prize is *for*, so its identity is withheld until the player confirms —
 * otherwise the ceremony is defeated by reading the WebSocket frame, on every surface at once
 * (secrecy is a platform property, not a per-surface one). The count of entries is still here,
 * which is all "you won 2 prizes" needs. The identity arrives afterwards, on
 * `PrizeRevealedNotification`.
 *
 * Deliberately no `payout_id` either (ticket #3804 QA): the payout reference is a claim
 * implementation detail, not player-facing data — it stays in the persisted `data.prizes`
 * (see `to_payload`) so `ack_player_notifications` can resolve it server-side, and is never
 * put on the wire.
 */
export interface PrizeDropWonPrizeSchema {
  drop_key: DropKey;
  [k: string]: unknown;
}
export interface PrizeDropRevealedNotificationSchema {
  id: Id29;
  created_at: CreatedAt18;
  campaign_id: CampaignId19;
  type?: Type19;
  prizes: Prizes4;
  [k: string]: unknown;
}
/**
 * One just-revealed prize: the identity the pre-reveal payload withheld, keyed by the same
 * `drop_key` the client echoed in its ack so it can join this onto the card it just confirmed.
 *
 * `games` is the prize's own game names (free-spins prizes only; `[]` otherwise), resolved
 * exactly as the `campaigns`/`prize_drop_prizes` streams resolve theirs — carried here so the
 * client never has to match a title back to a prize tier to find them. No count field: the list
 * is complete (the backend never previews it), so the client derives any count it wants.
 */
export interface PrizeDropRevealedPrizeSchema {
  drop_key: DropKey1;
  title: Title4;
  games?: Games1;
  [k: string]: unknown;
}
export interface PrizeDropNearWinNotificationSchema {
  id: Id30;
  created_at: CreatedAt19;
  campaign_id: CampaignId20;
  type?: Type20;
  [k: string]: unknown;
}
export interface PrizeDropNearDropNotificationSchema {
  id: Id31;
  created_at: CreatedAt20;
  campaign_id: CampaignId21;
  type?: Type21;
  [k: string]: unknown;
}
export interface PrizeDropPlayerEnteredNotificationSchema {
  id: Id32;
  created_at: CreatedAt21;
  campaign_id: CampaignId22;
  type?: Type22;
  [k: string]: unknown;
}
export interface PrizeDropChanceIncreaseNotificationSchema {
  id: Id33;
  created_at: CreatedAt22;
  campaign_id: CampaignId23;
  type?: Type23;
  [k: string]: unknown;
}
export interface PrizeDropChanceDecreaseNotificationSchema {
  id: Id34;
  created_at: CreatedAt23;
  campaign_id: CampaignId24;
  type?: Type24;
  [k: string]: unknown;
}
export interface PrizeDropCampaignLiveNotificationSchema {
  id: Id35;
  created_at: CreatedAt24;
  campaign_id: CampaignId25;
  type?: Type25;
  [k: string]: unknown;
}
export interface PrizeDropHotPeriodNotificationSchema {
  id: Id36;
  created_at: CreatedAt25;
  campaign_id: CampaignId26;
  type?: Type26;
  [k: string]: unknown;
}
export interface PrizeDropFinalStretchNotificationSchema {
  id: Id37;
  created_at: CreatedAt26;
  campaign_id: CampaignId27;
  type?: Type27;
  [k: string]: unknown;
}
export interface NotificationsUpdate {
  type: UpdateNotifications;
  result: Result;
  data: Data9;
  [k: string]: unknown;
}
export interface AckNotificationsResponse {
  type: AckNotifications;
  result: Result;
  [k: string]: unknown;
}
export interface PrizeDropPrizesResponse {
  type: SubscribePrizeDropPrizes;
  result: Result;
  data?: Data10;
  [k: string]: unknown;
}
/**
 * The `prize_drop_prizes` stream element: the volatile prize state for one DP campaign, plus
 * the fixed `max_prizes_per_player` tail. `id`/`custom_id` are the CAMPAIGN identifiers so the FE
 * can join this against the `campaigns` and `campaign_progress` streams.
 */
export interface PrizeDropPrizesSchema {
  id: Id38;
  custom_id: CustomId4;
  prizes: Prizes5;
  max_prizes_per_player?: MaxPrizesPerPlayer;
  [k: string]: unknown;
}
/**
 * One prize row of a dynamic prize drop — mirrors TournamentPrizeSchema.
 */
export interface PrizeDropPrizeSchema {
  title: Title5;
  games?: Games2;
  is_catalog_item?: IsCatalogItem1;
  quantity: Quantity1;
  left_to_win: LeftToWin1;
  [k: string]: unknown;
}
export interface PrizeDropPrizesUpdate {
  type: UpdatePrizeDropPrizes;
  result: Result;
  data: Data11;
  [k: string]: unknown;
}
export interface RaffleProgressResponse {
  type: SubscribeRaffleProgress;
  result: Result;
  data?: Data12;
  [k: string]: unknown;
}
export interface RaffleProgressSchema {
  campaign_id: CampaignId28;
  campaign_custom_id: CampaignCustomId1;
  total_tickets: TotalTickets;
  tasks: Tasks4;
  [k: string]: unknown;
}
export interface RaffleTaskProgressSchema {
  task_id: TaskId1;
  progress: ProgressSchema;
  tickets: Tickets;
  max_tickets: MaxTickets1;
  [k: string]: unknown;
}
export interface RaffleProgressUpdate {
  type: UpdateRaffleProgress;
  result: Result;
  data: Data13;
  [k: string]: unknown;
}
export interface SprintMissionPoolResponse {
  type: SubscribeSprintMissionPool;
  result: Result;
  data?: Data14;
  [k: string]: unknown;
}
/**
 * The `sprint_mission_pool` stream element: the volatile pool facts for one Sprint Mission
 * campaign (#3847 task 6) — the slot counter and, since #3958, the recent winners feed.
 *
 * `id`/`custom_id` are the CAMPAIGN identifiers, so the FE joins this against the `campaigns`,
 * `campaign_progress` and `mission_progress` streams on the same key — mirroring
 * `PrizeDropPrizesSchema`.
 *
 * Both facts move on the same event (a claim) and are identical for every player, which is
 * what makes them pool-stream data. Everything structural about the mission (tasks, prizes,
 * terms) rides the `campaigns` stream, and per-player progress rides `mission_progress`;
 * widening either with pool data would break `widgets/CLAUDE.md` invariant 3.
 */
export interface SprintMissionPoolSchema {
  id: Id39;
  custom_id: CustomId5;
  prize_pool_size: PrizePoolSize;
  prizes_remaining: PrizesRemaining;
  exhausted: Exhausted;
  payout_timing: PayoutTiming;
  recent_winners: RecentWinners;
  [k: string]: unknown;
}
/**
 * One recent slot holder, for the "latest wins" feed (#3958). `name` is the platform's
 * already-masked username ("ale**").
 *
 * `player` is the platform's opaque hash, carried for one reason: this stream is SHARED, so a
 * per-player "that row is you" flag cannot live on it. The client compares the hash with its
 * own and renders "You", exactly as `LeaderboardEntrySchema` already does for a tournament.
 */
export interface SprintMissionWinnerSchema {
  player: Player2;
  name: Name3;
  slot: Slot;
  won_at: WonAt1;
  [k: string]: unknown;
}
export interface SprintMissionPoolUpdate {
  type: UpdateSprintMissionPool;
  result: Result;
  data: Data15;
  [k: string]: unknown;
}
export interface TournamentLeaderboardsResponse {
  type: SubscribeTournamentLeaderboards;
  result: Result;
  data?: Data16;
  [k: string]: unknown;
}
/**
 * The `tournament_leaderboards` stream element: the volatile leaderboard for one tournament.
 * `id`/`custom_id` are the CAMPAIGN identifiers so the FE can join this against the `campaigns`
 * and `campaign_progress` streams (mirrors PrizeDropPrizesSchema).
 */
export interface TournamentLeaderboardsSchema {
  id: Id40;
  custom_id: CustomId6;
  leaderboard: Leaderboard;
  [k: string]: unknown;
}
export interface LeaderboardEntrySchema {
  player: Player3;
  score: Score;
  rank: Rank;
  [k: string]: unknown;
}
export interface TournamentLeaderboardsUpdate {
  type: UpdateTournamentLeaderboards;
  result: Result;
  data: Data17;
  [k: string]: unknown;
}
export interface TournamentPlayerProgressResponse {
  type: SubscribeTournamentProgress;
  result: Result;
  data?: Data18;
  [k: string]: unknown;
}
export interface PlayerTournamentProgressSchema {
  id: Id41;
  custom_id: CustomId7;
  joined: Joined1;
  leaderboard_position: LeaderboardPosition;
  score: Score1;
  left_spins?: LeftSpins;
  current?: Current1;
  total?: Total2;
  can_reset?: CanReset;
  prizes: Prizes6;
  tasks?: Tasks5;
  [k: string]: unknown;
}
export interface CampaignWinningSchema {
  title: Title6;
  attempts?: Attempts1;
  [k: string]: unknown;
}
export interface TournamentPlayerProgressUpdate {
  type: UpdateTournamentProgress;
  result: Result;
  data: Data19;
  [k: string]: unknown;
}
export interface OptInTournamentResponse {
  type: OptInTournament;
  result: Result1;
  [k: string]: unknown;
}
export interface OptOutTournamentResponse {
  type: OptOutTournament;
  result: Result2;
  [k: string]: unknown;
}
export interface RestartTournamentResponse {
  type: RestartTournament;
  result: Result3;
  [k: string]: unknown;
}

// --- Runtime consts and type guards (from schema) ---
/** Union of all WebSocket message types from backend schema (inferred, not hardcoded). */
export type WebSocketResponse = GeneratedTypes;

// Runtime consts for literal types (use in value position)
export const SetPlayer = "set_player" as const;
export const Authenticate = "authenticate" as const;
export const SubscribeCampaigns = "subscribe:campaigns" as const;
export const UpdateCampaigns = "update:campaigns" as const;
export const SubscribeCampaignProgress = "subscribe:campaign_progress" as const;
export const UpdateCampaignProgress = "update:campaign_progress" as const;
export const Configure = "configure" as const;
export const ListGames = "action:list_games" as const;
export const GameCampaigns = "action:game_campaigns" as const;
export const SubscribeJackpotProgress = "subscribe:jackpot_progress" as const;
export const UpdateJackpotProgress = "update:jackpot_progress" as const;
export const SubscribeMissionProgress = "subscribe:mission_progress" as const;
export const UpdateMissionProgress = "update:mission_progress" as const;
export const SubscribeNotifications = "subscribe:notifications" as const;
export const Type1 = "bet_too_low" as const;
export const Type2 = "bet_bonus_excluded" as const;
export const Type3 = "jackpot_won" as const;
export const Type4 = "mission_completed" as const;
export const Type5 = "mission_secondary_task_complete" as const;
export const Type6 = "mission_prize_pool_exhausted" as const;
export const Type7 = "tournament_finished" as const;
export const Type8 = "tournament_race_finished" as const;
export const Type9 = "tournament_chase_win_prize" as const;
export const Type10 = "tournament_secondary_finished" as const;
export const Type11 = "tournament_secondary_race_finished" as const;
export const Type12 = "tournament_race_completed" as const;
export const Type13 = "tournament_secondary_mission_complete" as const;
export const Type14 = "tournament_new_high_score" as const;
export const Type15 = "tournament_secondary_task_complete" as const;
export const Type16 = "tournament_reset_best_score" as const;
export const Type17 = "tournament_reset_worst_prize" as const;
export const Type18 = "prize_drop_won" as const;
export const Type19 = "prize_drop_revealed" as const;
export const Type20 = "prize_drop_near_win" as const;
export const Type21 = "prize_drop_near_drop" as const;
export const Type22 = "prize_drop_player_entered" as const;
export const Type23 = "prize_drop_chance_increase" as const;
export const Type24 = "prize_drop_chance_decrease" as const;
export const Type25 = "prize_drop_campaign_live" as const;
export const Type26 = "prize_drop_hot_period" as const;
export const Type27 = "prize_drop_final_stretch" as const;
export const UpdateNotifications = "update:notifications" as const;
export const AckNotifications = "ack:notifications" as const;
export const SubscribePrizeDropPrizes = "subscribe:prize_drop_prizes" as const;
export const UpdatePrizeDropPrizes = "update:prize_drop_prizes" as const;
export const SubscribeRaffleProgress = "subscribe:raffle_progress" as const;
export const UpdateRaffleProgress = "update:raffle_progress" as const;
export const SubscribeSprintMissionPool = "subscribe:sprint_mission_pool" as const;
export const UpdateSprintMissionPool = "update:sprint_mission_pool" as const;
export const SubscribeTournamentLeaderboards = "subscribe:tournament_leaderboards" as const;
export const UpdateTournamentLeaderboards = "update:tournament_leaderboards" as const;
export const SubscribeTournamentProgress = "subscribe:tournament_progress" as const;
export const UpdateTournamentProgress = "update:tournament_progress" as const;
export const OptInTournament = "action:opt_in" as const;
export const OptOutTournament = "action:opt_out" as const;
export const RestartTournament = "action:restart_tournament" as const;

export const RESULT = { OK: "ok", ERROR: "error" } as const;

// Type guards for discriminated union
export function isAckNotificationsResponse(message: WebSocketResponse | AckNotificationsResponse): message is AckNotificationsResponse {
  return message.type === AckNotifications;
}

export function isGameCampaignsResponse(message: WebSocketResponse | GameCampaignsResponse): message is GameCampaignsResponse {
  return message.type === GameCampaigns;
}

export function isListGamesResponse(message: WebSocketResponse | ListGamesResponse): message is ListGamesResponse {
  return message.type === ListGames;
}

export function isOptInTournamentResponse(message: WebSocketResponse | OptInTournamentResponse): message is OptInTournamentResponse {
  return message.type === OptInTournament;
}

export function isOptOutTournamentResponse(message: WebSocketResponse | OptOutTournamentResponse): message is OptOutTournamentResponse {
  return message.type === OptOutTournament;
}

export function isRestartTournamentResponse(message: WebSocketResponse | RestartTournamentResponse): message is RestartTournamentResponse {
  return message.type === RestartTournament;
}

export function isAuthenticateResponse(message: WebSocketResponse | AuthenticateResponse): message is AuthenticateResponse {
  return message.type === Authenticate;
}

export function isConfigureResponse(message: WebSocketResponse | ConfigureResponse): message is ConfigureResponse {
  return message.type === Configure;
}

export function isSetPlayerResponse(message: WebSocketResponse | SetPlayerResponse): message is SetPlayerResponse {
  return message.type === SetPlayer;
}

export function isCampaignProgressResponse(message: WebSocketResponse | CampaignProgressResponse): message is CampaignProgressResponse {
  return message.type === SubscribeCampaignProgress;
}

export function isCampaignsResponse(message: WebSocketResponse | CampaignsResponse): message is CampaignsResponse {
  return message.type === SubscribeCampaigns;
}

export function isJackpotProgressResponse(message: WebSocketResponse | JackpotProgressResponse): message is JackpotProgressResponse {
  return message.type === SubscribeJackpotProgress;
}

export function isMissionProgressResponse(message: WebSocketResponse | MissionProgressResponse): message is MissionProgressResponse {
  return message.type === SubscribeMissionProgress;
}

export function isNotificationsResponse(message: WebSocketResponse | NotificationsResponse): message is NotificationsResponse {
  return message.type === SubscribeNotifications;
}

export function isPrizeDropPrizesResponse(message: WebSocketResponse | PrizeDropPrizesResponse): message is PrizeDropPrizesResponse {
  return message.type === SubscribePrizeDropPrizes;
}

export function isRaffleProgressResponse(message: WebSocketResponse | RaffleProgressResponse): message is RaffleProgressResponse {
  return message.type === SubscribeRaffleProgress;
}

export function isSprintMissionPoolResponse(message: WebSocketResponse | SprintMissionPoolResponse): message is SprintMissionPoolResponse {
  return message.type === SubscribeSprintMissionPool;
}

export function isTournamentLeaderboardsResponse(message: WebSocketResponse | TournamentLeaderboardsResponse): message is TournamentLeaderboardsResponse {
  return message.type === SubscribeTournamentLeaderboards;
}

export function isTournamentPlayerProgressResponse(message: WebSocketResponse | TournamentPlayerProgressResponse): message is TournamentPlayerProgressResponse {
  return message.type === SubscribeTournamentProgress;
}

export function isCampaignProgressUpdate(message: WebSocketResponse | CampaignProgressUpdate): message is CampaignProgressUpdate {
  return message.type === UpdateCampaignProgress;
}

export function isCampaignsUpdate(message: WebSocketResponse | CampaignsUpdate): message is CampaignsUpdate {
  return message.type === UpdateCampaigns;
}

export function isJackpotProgressUpdate(message: WebSocketResponse | JackpotProgressUpdate): message is JackpotProgressUpdate {
  return message.type === UpdateJackpotProgress;
}

export function isMissionProgressUpdate(message: WebSocketResponse | MissionProgressUpdate): message is MissionProgressUpdate {
  return message.type === UpdateMissionProgress;
}

export function isNotificationsUpdate(message: WebSocketResponse | NotificationsUpdate): message is NotificationsUpdate {
  return message.type === UpdateNotifications;
}

export function isPrizeDropPrizesUpdate(message: WebSocketResponse | PrizeDropPrizesUpdate): message is PrizeDropPrizesUpdate {
  return message.type === UpdatePrizeDropPrizes;
}

export function isRaffleProgressUpdate(message: WebSocketResponse | RaffleProgressUpdate): message is RaffleProgressUpdate {
  return message.type === UpdateRaffleProgress;
}

export function isSprintMissionPoolUpdate(message: WebSocketResponse | SprintMissionPoolUpdate): message is SprintMissionPoolUpdate {
  return message.type === UpdateSprintMissionPool;
}

export function isTournamentLeaderboardsUpdate(message: WebSocketResponse | TournamentLeaderboardsUpdate): message is TournamentLeaderboardsUpdate {
  return message.type === UpdateTournamentLeaderboards;
}

export function isTournamentPlayerProgressUpdate(message: WebSocketResponse | TournamentPlayerProgressUpdate): message is TournamentPlayerProgressUpdate {
  return message.type === UpdateTournamentProgress;
}
